<template>
  <v-container fluid class="diag-adocao pa-4 pa-md-6" style="margin-top: 2%">
    <v-card outlined class="pa-4 mb-4 toolbar-card">
      <v-form ref="form" v-model="formValidado">
        <v-row dense>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              v-model="idClientesSelected"
              :items="clientes"
              item-text="nome_cliente"
              item-value="id_cliente"
              clearable
              multiple
              chips
              small-chips
              deletable-chips
              :label="$tc('client.self', 1)"
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <MultiplaEscolha
              :items="unidades"
              v-bind:selected-items.sync="idUnidadesSelected"
              text="descricao_unidade"
              value="id_unidade"
              :label="$t('diagSystemAdoption.filters.cad')"
              :max-items="10"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              v-model="lideresSelected"
              :items="lideres"
              clearable
              multiple
              chips
              small-chips
              deletable-chips
              :label="$t('diagSystemAdoption.filters.manager')"
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              v-model="idTurnosViagemSelected"
              :items="turnosViagem"
              item-text="descricao_turno"
              item-value="id_turno"
              clearable
              multiple
              chips
              small-chips
              deletable-chips
              :label="$t('diagSystemAdoption.filters.shift')"
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              v-model="idEscalasSelected"
              :items="escalasDisplay"
              item-text="descricao_turno"
              item-value="id_turno"
              clearable
              multiple
              chips
              small-chips
              deletable-chips
              :label="$t('diagSystemAdoption.filters.schedule')"
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <div class="caption grey--text mb-1">{{ $t('diagSystemAdoption.filters.type') }}</div>
            <v-btn-toggle v-model="tipoSelected" mandatory dense>
              <v-btn small value="todos">{{ $t('diagSystemAdoption.filters.typeAll') }}</v-btn>
              <v-btn small value="ml">{{ $t('diagSystemAdoption.filters.typeMl') }}</v-btn>
              <v-btn small value="terceiro">{{ $t('diagSystemAdoption.filters.typeThird') }}</v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col cols="12" sm="4" md="2">
            <v-datetime-picker
              :label="$t('datetime.startDate')"
              v-model="dti"
              :time-picker-props="timeProps"
              :text-field-props="textFieldProps"
              :date-picker-props="{}"
              time-format="HH:mm:ss"
              date-format="dd/MM/yyyy"
              :clear-text="$t('datetime.close')"
            >
              <template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
              <template slot="timeIcon"><v-icon>mdi-clock</v-icon></template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="2">
            <v-datetime-picker
              :label="$t('datetime.finalDate')"
              v-model="dtf"
              :time-picker-props="timeProps"
              :text-field-props="textFieldProps"
              :date-picker-props="dtfProps"
              time-format="HH:mm:ss"
              date-format="dd/MM/yyyy"
              :clear-text="$t('datetime.close')"
            >
              <template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
              <template slot="timeIcon"><v-icon>mdi-clock</v-icon></template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="2">
            <v-text-field
              v-model.number="diasInativo"
              type="number"
              min="1"
              :label="$t('diagSystemAdoption.filters.inactiveDays')"
              :hint="$t('diagSystemAdoption.filters.inactiveDaysHint')"
              persistent-hint
            />
          </v-col>
          <v-col cols="12" sm="6" md="2" class="d-flex align-center">
            <v-btn text color="primary" class="mr-2" @click="limparFiltros">
              {{ $t('diagSystemAdoption.filters.clear') }}
            </v-btn>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  fab
                  color="primary darken-1"
                  class="white--text mr-2"
                  v-bind="attrs"
                  v-on="on"
                  :loading="loadingResumo"
                  @click="populaRelatorio"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  fab
                  color="primary darken-1"
                  class="white--text"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!hasKpis || loadingResumo"
                  :loading="loadingPdf"
                  @click="exportarAnalisePdf"
                >
                  <v-icon>mdi-file-pdf-box</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('diagSystemAdoption.exportPdf') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <v-overlay :value="loadingPdf" z-index="9999">
      <div class="text-center white--text">
        <v-progress-circular indeterminate color="white" size="48" class="mb-3" />
        <div>{{ $t('diagSystemAdoption.exportingPdf') }}</div>
      </div>
    </v-overlay>

    <v-tabs v-model="tab" background-color="transparent" show-arrows class="mb-2">
      <v-tab>{{ $t('diagSystemAdoption.tabs.executive') }}</v-tab>
      <v-tab :disabled="!hasKpis">{{ $t('diagSystemAdoption.tabs.byCad') }}</v-tab>
      <v-tab :disabled="!hasKpis">{{ $t('diagSystemAdoption.tabs.byManager') }}</v-tab>
      <v-tab :disabled="!hasKpis">{{ $t('diagSystemAdoption.tabs.byClient') }}</v-tab>
      <v-tab :disabled="!hasKpis">{{ $t('diagSystemAdoption.tabs.mlVsThird') }}</v-tab>
      <v-tab :disabled="!hasKpis">{{ $t('diagSystemAdoption.tabs.scheduleShift') }}</v-tab>
      <v-tab :disabled="!hasKpis">{{ $t('diagSystemAdoption.tabs.analyticalBase') }}</v-tab>
    </v-tabs>

    <!-- Visão Executiva -->
    <div v-show="tab === 0" ref="sectionExecutive">
      <div v-if="loadingResumo" class="text-center py-10">
        <v-progress-circular indeterminate color="primary" />
      </div>
      <template v-else-if="hasKpis">
        <v-row class="mt-2 mb-2" dense>
          <v-col
            v-for="card in kpiCards"
            :key="card.key"
            cols="12"
            sm="6"
            md="4"
            lg
            class="d-flex"
          >
            <v-card
              class="pa-3 flex-grow-1 kpi-card"
              :class="{
                'kpi-card--clickable': card.clickable,
                'kpi-card--selected': card.clickable && selectedKpi === card.key,
              }"
              :style="{ borderTop: `4px solid ${card.color}` }"
              :role="card.clickable ? 'button' : undefined"
              :tabindex="card.clickable ? 0 : undefined"
              @click="card.clickable && onStatusClick(card.key)"
              @keydown.enter.prevent="card.clickable && onStatusClick(card.key)"
              @keydown.space.prevent="card.clickable && onStatusClick(card.key)"
            >
              <div class="text-caption text-uppercase font-weight-medium grey--text text--darken-1">
                {{ card.label }}
              </div>
              <div class="text-h5 font-weight-bold mt-1" :style="{ color: card.color }">
                {{ card.display }}
              </div>
              <div v-if="card.subtitle" class="caption mt-1 grey--text text--darken-1">
                {{ card.subtitle }}
              </div>
              <div v-if="card.clickable" class="caption mt-2 primary--text">
                {{
                  selectedKpi === card.key
                    ? $t('diagSystemAdoption.kpiTable.clickToClose')
                    : $t('diagSystemAdoption.kpiTable.clickToOpen')
                }}
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-alert
          type="info"
          colored-border
          border="left"
          dense
          class="mt-2 mb-4"
          color="amber darken-2"
        >
          <div class="font-weight-bold mb-1">
            {{ $t('diagSystemAdoption.inactiveDefinition.title') }}
          </div>
          <div>
            {{ $t('diagSystemAdoption.inactiveDefinition.body', { days: diasInativo || 7 }) }}
          </div>
        </v-alert>

        <v-row dense>
          <v-col cols="12" md="5">
            <v-card class="pa-4 chart-card">
              <div class="text-subtitle-1 font-weight-bold mb-2">
                {{ $t('diagSystemAdoption.charts.adoptionStatus') }}
              </div>
              <div v-if="donutHasData" class="caption grey--text mb-1">
                {{ $t('diagSystemAdoption.kpiTable.chartHint') }}
              </div>
              <apexchart
                v-if="donutHasData"
                type="donut"
                height="360"
                :options="donutOptions"
                :series="donutSeries"
                @dataPointSelection="onDonutDataPointSelection"
                @legendClick="onDonutLegendClick"
              />
              <div v-else class="caption grey--text py-8 text-center">
                {{ $t('diagSystemAdoption.charts.noData') }}
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="7">
            <v-card class="pa-4 chart-card">
              <div class="d-flex align-center justify-space-between mb-2 flex-wrap">
                <div class="text-subtitle-1 font-weight-bold">
                  {{ $t('diagSystemAdoption.charts.evolution') }}
                </div>
                <v-btn-toggle v-if="!loadingPdf" v-model="evolucaoGranularidade" mandatory dense>
                  <v-btn small value="diario">{{ $t('diagSystemAdoption.charts.daily') }}</v-btn>
                  <v-btn small value="semanal">{{ $t('diagSystemAdoption.charts.weekly') }}</v-btn>
                  <v-btn small value="mensal">{{ $t('diagSystemAdoption.charts.monthly') }}</v-btn>
                </v-btn-toggle>
                <div v-else class="caption grey--text">
                  {{ evolucaoGranularidadeLabel }}
                </div>
              </div>
              <apexchart
                v-if="evolucaoHasData"
                type="line"
                height="360"
                :options="evolucaoOptions"
                :series="evolucaoSeries"
              />
              <div v-else class="caption grey--text py-8 text-center">
                {{ $t('diagSystemAdoption.charts.noData') }}
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-card v-if="selectedKpi" class="pa-2 mt-4 mb-2 chart-card" ref="sectionKpiTable">
          <div v-if="loadingKpiTable" class="text-center py-8">
            <v-progress-circular indeterminate color="primary" />
          </div>
          <template v-else>
            <div class="d-flex align-center justify-space-between flex-wrap px-2 pt-2">
              <div class="text-subtitle-1 font-weight-bold">
                {{ selectedKpiTitle }}
                <span class="caption grey--text font-weight-regular ml-2">
                  ({{ kpiPassageirosDisplay.length }})
                </span>
              </div>
              <v-btn text small color="primary" @click="fecharKpiTable">
                {{ $t('diagSystemAdoption.kpiTable.close') }}
              </v-btn>
            </div>
            <merus-data-table
              :key="'kpi-' + selectedKpi + '-' + tableKey"
              :headers="kpiHeaders"
              :items="kpiPassageirosDisplay"
              :loading="false"
              item-key="id_pessoa"
              cod-tabela="DIAGADOCAOSISTEMA__PASSAGEIROS"
              @update:headers="kpiHeaders = $event"
            >
              <template v-slot:toolbar>
                <CadastroToolbar
                  :title="selectedKpiTitle"
                  :token="token"
                  :items="kpiPassageirosDisplay"
                  :csv-title="'adocaosistema_' + (selectedKpi || 'kpi')"
                  :csv-headers="kpiHeaders"
                  :pdf-title="selectedKpiTitle"
                  :pdf-headers="kpiHeaders"
                  :pdf-filename="'adocaosistema_' + (selectedKpi || 'kpi')"
                  hide-search
                />
              </template>
            </merus-data-table>
          </template>
        </v-card>
      </template>
      <v-alert v-else type="info" text class="mt-4">
        {{ $t('diagSystemAdoption.searchPrompt') }}
      </v-alert>
    </div>

    <!-- Abas de agrupamento (mesmo componente; dados mudam) -->
    <div v-show="tab >= 1 && tab <= 4" ref="sectionGroup">
      <div v-if="loadingTab[activeGroupKey]" class="text-center py-10">
        <v-progress-circular indeterminate color="primary" />
      </div>
      <DIAGAdocaoSistemaGrupo
        v-else-if="hasKpis"
        ref="groupComp"
        :title="activeGroupTitle"
        :rows="activeGroupRows"
        :group-header="activeGroupHeader"
      />
    </div>

    <!-- Escala e Turno -->
    <div v-show="tab === 5" ref="sectionSchedule">
      <div v-if="loadingTab.escala_turno" class="text-center py-10">
        <v-progress-circular indeterminate color="primary" />
      </div>
      <template v-else-if="hasKpis">
        <DIAGAdocaoSistemaGrupo
          ref="groupSchedule"
          :title="$t('diagSystemAdoption.group.bySchedule')"
          :rows="agrupamentoEscalaRows"
          :group-header="$t('diagSystemAdoption.filters.schedule')"
        />
        <v-alert dense text type="info" class="mt-4 mb-2">
          {{ $t('diagSystemAdoption.group.tripShiftHint') }}
        </v-alert>
        <DIAGAdocaoSistemaGrupo
          ref="groupShift"
          :title="$t('diagSystemAdoption.group.byTripShift')"
          :rows="agrupamentos.por_turno_viagem"
          :group-header="$t('diagSystemAdoption.filters.shift')"
          compact
        />
      </template>
    </div>

    <!-- Base Analítica -->
    <div v-show="tab === 6" ref="sectionBase">
      <div v-if="loadingTab.base" class="text-center py-10">
        <v-progress-circular indeterminate color="primary" />
      </div>
      <v-card v-else-if="hasKpis" class="pa-2 mt-2 chart-card">
        <v-alert dense text type="info" class="mb-2 mx-2 mt-2">
          {{ $t('diagSystemAdoption.base.boardingsHint') }}
        </v-alert>
        <merus-data-table
          :key="'base-' + tableKey"
          :headers="baseHeaders"
          :items="baseAnaliticaDisplay"
          :loading="false"
          item-key="id_embarque"
          cod-tabela="DIAGADOCAOSISTEMA__BASE"
          @update:headers="baseHeaders = $event"
        >
          <template v-slot:toolbar>
            <CadastroToolbar
              :title="$t('diagSystemAdoption.tabs.analyticalBase')"
              :token="token"
              :items="baseAnaliticaDisplay"
              csv-title="adocaosistema_base"
              :csv-headers="baseHeaders"
              :pdf-title="$t('diagSystemAdoption.tabs.analyticalBase')"
              :pdf-headers="baseHeaders"
              pdf-filename="adocaosistema_base"
              hide-search
            />
          </template>
        </merus-data-table>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import apiController from '@/utils/apiController';
import DateUtils from '../utils/dateutils.js';
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import DIAGAdocaoSistemaGrupo from './DIAGAdocaoSistemaGrupo.vue';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import translatePassengerShiftDescription from '@/utils/translatePassengerShift';

function formatNumber(n) {
  const v = Number(n) || 0;
  return v.toLocaleString('pt-BR');
}

function formatPct(n) {
  const v = Number(n) || 0;
  return `${v.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
}

const TAB_DIMENSAO = {
  1: 'cad',
  2: 'gestor',
  3: 'cliente',
  4: 'tipo',
  5: 'escala_turno',
  6: 'base',
};

export default {
  name: 'DIAGAdocaoSistema',
  components: {
    MultiplaEscolha,
    MerusDataTable,
    CadastroToolbar,
    DIAGAdocaoSistemaGrupo,
  },
  data: () => ({
    user: null,
    token: null,
    formValidado: false,
    config: null,
    dti: null,
    dtf: null,
    timeProps: { useSeconds: true },
    diasInativo: 7,
    tipoSelected: 'todos',
    idClientesSelected: [],
    idUnidadesSelected: [],
    lideresSelected: [],
    idTurnosViagemSelected: [],
    idEscalasSelected: [],
    clientes: [],
    unidades: [],
    lideres: [],
    turnosViagem: [],
    escalas: [],
    tab: 0,
    kpis: null,
    statusAdesao: [],
    evolucao: { diario: [], semanal: [], mensal: [] },
    agrupamentos: {
      por_cad: [],
      por_gestor: [],
      por_cliente: [],
      por_tipo: [],
      por_escala: [],
      por_turno_viagem: [],
    },
    tabLoaded: {
      cad: false,
      gestor: false,
      cliente: false,
      tipo: false,
      escala_turno: false,
      base: false,
    },
    loadingTab: {
      cad: false,
      gestor: false,
      cliente: false,
      tipo: false,
      escala_turno: false,
      base: false,
    },
    baseAnalitica: [],
    evolucaoGranularidade: 'diario',
    loadingResumo: false,
    loadingPdf: false,
    baseHeaders: [],
    lastFilterKey: null,
    selectedKpi: null,
    kpiPassageiros: [],
    loadingKpiTable: false,
    kpiHeaders: [],
  }),
  computed: {
    tableKey() {
      return `adocao-${this.$i18n.locale}`;
    },
    evolucaoGranularidadeLabel() {
      const map = {
        diario: this.$t('diagSystemAdoption.charts.daily'),
        semanal: this.$t('diagSystemAdoption.charts.weekly'),
        mensal: this.$t('diagSystemAdoption.charts.monthly'),
      };
      return map[this.evolucaoGranularidade] || '';
    },
    textFieldProps() {
      return {
        prependInnerIcon: 'mdi-calendar',
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')],
      };
    },
    dtfProps() {
      let min = null;
      if (this.dti) {
        if (typeof this.dti === 'string') {
          min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
        } else {
          min = this.dti.toISOString().substring(0, 10);
        }
      }
      return { min };
    },
    hasKpis() {
      return !!this.kpis;
    },
    activeGroupKey() {
      return TAB_DIMENSAO[this.tab] || null;
    },
    activeGroupTitle() {
      const map = {
        cad: this.$t('diagSystemAdoption.tabs.byCad'),
        gestor: this.$t('diagSystemAdoption.tabs.byManager'),
        cliente: this.$t('diagSystemAdoption.tabs.byClient'),
        tipo: this.$t('diagSystemAdoption.tabs.mlVsThird'),
      };
      return map[this.activeGroupKey] || '';
    },
    currentTabTitle() {
      const titles = [
        this.$t('diagSystemAdoption.tabs.executive'),
        this.$t('diagSystemAdoption.tabs.byCad'),
        this.$t('diagSystemAdoption.tabs.byManager'),
        this.$t('diagSystemAdoption.tabs.byClient'),
        this.$t('diagSystemAdoption.tabs.mlVsThird'),
        this.$t('diagSystemAdoption.tabs.scheduleShift'),
        this.$t('diagSystemAdoption.tabs.analyticalBase'),
      ];
      return titles[this.tab] || titles[0];
    },
    activeGroupHeader() {
      const map = {
        cad: this.$t('diagSystemAdoption.filters.cad'),
        gestor: this.$t('diagSystemAdoption.filters.manager'),
        cliente: this.$tc('client.self', 1),
        tipo: this.$t('diagSystemAdoption.filters.type'),
      };
      return map[this.activeGroupKey] || '';
    },
    activeGroupRows() {
      const map = {
        cad: this.agrupamentos.por_cad,
        gestor: this.agrupamentos.por_gestor,
        cliente: this.agrupamentos.por_cliente,
        tipo: this.agrupamentos.por_tipo,
      };
      return map[this.activeGroupKey] || [];
    },
    kpiCards() {
      if (!this.kpis) return [];
      const k = this.kpis;
      const elegiveis = k.passageiros_elegiveis != null ? k.passageiros_elegiveis : k.hc_elegivel;
      const aderencia =
        k.aderencia_passageiros_pct != null ? k.aderencia_passageiros_pct : k.aderencia_hc_pct;
      return [
        {
          key: 'passageiros',
          label: this.$t('diagSystemAdoption.kpis.eligibleHc'),
          display: formatNumber(elegiveis),
          color: '#1565c0',
          subtitle: this.$t('diagSystemAdoption.kpis.eligibleHcSub', {
            withCheckin: formatNumber(k.aderiram_periodo),
          }),
          clickable: false,
        },
        {
          key: 'aderencia',
          label: this.$t('diagSystemAdoption.kpis.hcAdherence'),
          display: formatPct(aderencia),
          color: '#c62828',
          subtitle: this.$t('diagSystemAdoption.kpis.hcAdherenceSub', {
            part: formatNumber(k.aderiram_periodo),
            total: formatNumber(elegiveis),
          }),
          clickable: false,
        },
        {
          key: 'nunca',
          label: this.$t('diagSystemAdoption.kpis.neverAdhered'),
          display: formatNumber(k.nunca_aderiram),
          color: '#ad1457',
          subtitle: formatPct(k.nunca_aderiram_pct),
          clickable: true,
        },
        {
          key: 'inativos',
          label: this.$t('diagSystemAdoption.kpis.inactive'),
          display: formatNumber(k.inativos),
          color: '#ef6c00',
          subtitle: formatPct(k.inativos_pct),
          clickable: true,
        },
        {
          key: 'unico',
          label: this.$t('diagSystemAdoption.kpis.singleCheckin'),
          display: formatNumber(k.unico_checkin),
          color: '#607d8b',
          subtitle: formatPct(k.unico_checkin_pct),
          clickable: true,
        },
      ];
    },
    donutHasData() {
      return (this.statusAdesao || []).some((s) => Number(s.qtd) > 0);
    },
    donutLabels() {
      const map = {
        nunca: this.$t('diagSystemAdoption.status.never'),
        inativos: this.$t('diagSystemAdoption.status.inactive'),
        ativos: this.$t('diagSystemAdoption.status.active'),
        unico: this.$t('diagSystemAdoption.status.single'),
      };
      return (this.statusAdesao || []).map((s) => map[s.key] || s.label);
    },
    donutSeries() {
      return (this.statusAdesao || []).map((s) => Number(s.qtd) || 0);
    },
    donutOptions() {
      return {
        chart: {
          type: 'donut',
          toolbar: { show: false },
          animations: { enabled: !this.loadingPdf },
        },
        labels: this.donutLabels,
        colors: ['#c62828', '#ef6c00', '#2e7d32', '#78909c'],
        legend: {
          position: 'bottom',
          onItemClick: { toggleDataSeries: false },
        },
        plotOptions: {
          pie: {
            donut: {
              labels: { show: true },
            },
          },
        },
        states: {
          active: { filter: { type: 'none' } },
        },
        dataLabels: {
          enabled: true,
          formatter: (val, opts) => {
            const qtd = opts.w.config.series[opts.seriesIndex] || 0;
            return `${formatNumber(qtd)} (${Number(val).toFixed(1)}%)`;
          },
        },
        tooltip: {
          y: { formatter: (val) => formatNumber(val) },
        },
      };
    },
    evolucaoRows() {
      const key = this.evolucaoGranularidade || 'diario';
      return (this.evolucao && this.evolucao[key]) || [];
    },
    evolucaoHasData() {
      return this.evolucaoRows.some(
        (r) => Number(r.pessoas) > 0 || Number(r.embarques) > 0
      );
    },
    evolucaoSeries() {
      const rows = this.evolucaoRows;
      return [
        {
          name: this.$t('diagSystemAdoption.charts.peopleSeries'),
          type: 'column',
          data: rows.map((r) => Number(r.pessoas) || 0),
        },
        {
          name: this.$t('diagSystemAdoption.charts.boardingsSeries'),
          type: 'column',
          data: rows.map((r) => Number(r.embarques) || 0),
        },
        {
          name: this.$t('diagSystemAdoption.charts.cumulativeSeries'),
          type: 'line',
          data: rows.map((r) => Number(r.aderencia_acumulada_pct) || 0),
        },
      ];
    },
    evolucaoOptions() {
      const categories = this.evolucaoRows.map((r) => r.periodo);
      return {
        chart: {
          type: 'line',
          stacked: false,
          toolbar: { show: false },
          animations: { enabled: !this.loadingPdf, speed: 400 },
        },
        stroke: { width: [0, 0, 3], curve: 'smooth' },
        plotOptions: {
          bar: { columnWidth: '55%', borderRadius: 2 },
        },
        colors: ['#1565c0', '#f9a825', '#2e7d32'],
        dataLabels: {
          enabled: true,
          enabledOnSeries: [0, 1, 2],
          formatter: (val, opts) => {
            if (opts.seriesIndex === 2) return `${Number(val).toFixed(1)}%`;
            return formatNumber(val);
          },
          style: { fontSize: '10px' },
        },
        xaxis: { categories },
        yaxis: [
          {
            seriesName: this.$t('diagSystemAdoption.charts.peopleSeries'),
            title: { text: this.$t('diagSystemAdoption.charts.volumeAxis') },
            labels: { formatter: (v) => formatNumber(v) },
          },
          {
            seriesName: this.$t('diagSystemAdoption.charts.peopleSeries'),
            show: false,
          },
          {
            opposite: true,
            seriesName: this.$t('diagSystemAdoption.charts.cumulativeSeries'),
            title: { text: this.$t('diagSystemAdoption.charts.pctAxis') },
            min: 0,
            max: 100,
            labels: { formatter: (v) => `${Number(v).toFixed(0)}%` },
          },
        ],
        legend: { position: 'bottom' },
        tooltip: { shared: true, intersect: false },
      };
    },
    baseAnaliticaDisplay() {
      const statusMap = {
        nunca: this.$t('diagSystemAdoption.status.never'),
        inativo: this.$t('diagSystemAdoption.status.inactive'),
        ativo: this.$t('diagSystemAdoption.status.active'),
        unico: this.$t('diagSystemAdoption.status.single'),
      };
      const tipoMap = {
        ml: this.$t('diagSystemAdoption.filters.typeMl'),
        terceiro: this.$t('diagSystemAdoption.filters.typeThird'),
      };
      const locale = this.$i18n.locale;
      return (this.baseAnalitica || []).map((r) => ({
        ...r,
        tipo_label: tipoMap[r.tipo] || r.tipo,
        status_label: statusMap[r.status_adesao] || r.status_adesao,
        escala: translatePassengerShiftDescription(r.escala, locale),
      }));
    },
    selectedKpiTitle() {
      const statusMap = {
        nunca: this.$t('diagSystemAdoption.status.never'),
        inativos: this.$t('diagSystemAdoption.status.inactive'),
        ativos: this.$t('diagSystemAdoption.status.active'),
        unico: this.$t('diagSystemAdoption.status.single'),
      };
      if (statusMap[this.selectedKpi]) {
        return this.$t('diagSystemAdoption.kpiTable.title', { kpi: statusMap[this.selectedKpi] });
      }
      const card = (this.kpiCards || []).find((c) => c.key === this.selectedKpi);
      return card
        ? this.$t('diagSystemAdoption.kpiTable.title', { kpi: card.label })
        : this.$t('diagSystemAdoption.kpiTable.titleFallback');
    },
    kpiPassageirosDisplay() {
      const statusMap = {
        nunca: this.$t('diagSystemAdoption.status.never'),
        inativo: this.$t('diagSystemAdoption.status.inactive'),
        ativo: this.$t('diagSystemAdoption.status.active'),
        unico: this.$t('diagSystemAdoption.status.single'),
      };
      const tipoMap = {
        ml: this.$t('diagSystemAdoption.filters.typeMl'),
        terceiro: this.$t('diagSystemAdoption.filters.typeThird'),
      };
      const locale = this.$i18n.locale;
      return (this.kpiPassageiros || []).map((r) => ({
        ...r,
        tipo_label: tipoMap[r.tipo] || r.tipo,
        status_label: statusMap[r.status_adesao] || r.status_adesao,
        escala: translatePassengerShiftDescription(r.escala, locale),
      }));
    },
    escalasDisplay() {
      const locale = this.$i18n.locale;
      return (this.escalas || []).map((t) => ({
        ...t,
        descricao_turno: translatePassengerShiftDescription(t.descricao_turno, locale),
      }));
    },
    agrupamentoEscalaRows() {
      const locale = this.$i18n.locale;
      return (this.agrupamentos.por_escala || []).map((r) => ({
        ...r,
        grupo_label: translatePassengerShiftDescription(r.grupo_label, locale),
      }));
    },
  },
  watch: {
    '$i18n.locale'() {
      this.initialize();
      this.buildBaseHeaders();
      this.buildKpiHeaders();
    },
    tab(newTab) {
      if (this.hasKpis) {
        this.ensureTabLoaded(newTab);
      }
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.token = sessionStorage.getItem('api');
    this.buildBaseHeaders();
    this.buildKpiHeaders();
    this.initialize();
  },
  methods: {
    buildBaseHeaders() {
      this.baseHeaders = [
        { text: this.$t('diagSystemAdoption.base.boardingAt'), value: 'dt_embarque_extenso', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.registration'), value: 'matricula', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.name'), value: 'nome_completo', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.cad'), value: 'cad', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.manager'), value: 'gestor', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.client'), value: 'cliente', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.type'), value: 'tipo_label', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.schedule'), value: 'escala', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.tripShift'), value: 'turno_viagem', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.line'), value: 'cod_linha', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.vehicle'), value: 'numero_ordem', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.stop'), value: 'cod_cerca', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.authorized'), value: 'autorizado_extenso', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.origin'), value: 'origem', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.status'), value: 'status_label', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.histCount'), value: 'hist_count', sortable: true, filtrable: false },
        { text: this.$t('diagSystemAdoption.base.periodCount'), value: 'periodo_count', sortable: true, filtrable: false },
      ];
    },
    buildKpiHeaders() {
      this.kpiHeaders = [
        { text: this.$t('diagSystemAdoption.base.registration'), value: 'matricula', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.name'), value: 'nome_completo', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.cad'), value: 'cad', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.manager'), value: 'gestor', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.client'), value: 'cliente', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.type'), value: 'tipo_label', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.schedule'), value: 'escala', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.status'), value: 'status_label', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.base.histCount'), value: 'hist_count', sortable: true, filtrable: false },
        { text: this.$t('diagSystemAdoption.base.periodCount'), value: 'periodo_count', sortable: true, filtrable: false },
        { text: this.$t('diagSystemAdoption.kpiTable.firstBoarding'), value: 'primeiro_embarque_extenso', sortable: true, filtrable: true },
        { text: this.$t('diagSystemAdoption.kpiTable.lastBoarding'), value: 'ultimo_embarque_extenso', sortable: true, filtrable: true },
      ];
    },
    initialize() {
      this.getConfig();
      this.populaClientes();
      this.populaUnidades();
      this.populaLideres();
      this.populaTurnosViagem();
      this.populaEscalas();
    },
    setDefaultLast7Days(horarioOperacional) {
      const hora = horarioOperacional || '00:00';
      const start = new Date();
      start.setDate(start.getDate() - 6);
      const dti = new Date(`${start.toISOString().substring(0, 10)}T${hora}:00`);
      const dtf = new Date();
      dtf.setHours(23, 59, 59, 999);
      this.dti = dti;
      this.dtf = dtf;
    },
    getConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        onSuccess: (response) => {
          this.config = (response.data && response.data[0]) || null;
          const hora =
            (this.config && this.config.hora_inicial_dia_operacao) || '00:00';
          this.setDefaultLast7Days(hora);
        },
        onError: () => {
          this.setDefaultLast7Days('00:00');
        },
      });
    },
    populaClientes() {
      apiController.request(apiController.endpoints.getClientesativos, {
        silent: true,
        onSuccess: (response) => {
          this.clientes = response.data || [];
        },
      });
    },
    populaUnidades() {
      apiController.request(apiController.endpoints.getallUnidadesativas, {
        silent: true,
        onSuccess: (response) => {
          this.unidades = response.data || [];
        },
      });
    },
    populaLideres() {
      apiController.request(apiController.endpoints.getAdocaosistemalideres, {
        silent: true,
        data: {},
        onSuccess: (response) => {
          this.lideres = response.data || [];
        },
      });
    },
    populaTurnosViagem() {
      apiController.request(apiController.endpoints.getallTurnos, {
        silent: true,
        onSuccess: (response) => {
          this.turnosViagem = (response.data || []).filter(
            (t) => t.ativo == null || Number(t.ativo) === 1
          );
        },
      });
    },
    populaEscalas() {
      apiController.request(apiController.endpoints.getallTurnospassageiros, {
        silent: true,
        onSuccess: (response) => {
          this.escalas = (response.data || []).filter(
            (t) => t.ativo == null || Number(t.ativo) === 1
          );
        },
      });
    },
    resetTabCache() {
      this.agrupamentos = {
        por_cad: [],
        por_gestor: [],
        por_cliente: [],
        por_tipo: [],
        por_escala: [],
        por_turno_viagem: [],
      };
      this.baseAnalitica = [];
      this.tabLoaded = {
        cad: false,
        gestor: false,
        cliente: false,
        tipo: false,
        escala_turno: false,
        base: false,
      };
      this.loadingTab = {
        cad: false,
        gestor: false,
        cliente: false,
        tipo: false,
        escala_turno: false,
        base: false,
      };
      this.fecharKpiTable();
    },
    limparFiltros() {
      this.idClientesSelected = [];
      this.idUnidadesSelected = [];
      this.lideresSelected = [];
      this.idTurnosViagemSelected = [];
      this.idEscalasSelected = [];
      this.tipoSelected = 'todos';
      this.diasInativo = 7;
      const hora =
        (this.config && this.config.hora_inicial_dia_operacao) || '00:00';
      this.setDefaultLast7Days(hora);
      this.kpis = null;
      this.statusAdesao = [];
      this.evolucao = { diario: [], semanal: [], mensal: [] };
      this.resetTabCache();
      this.tab = 0;
      this.lastFilterKey = null;
    },
    fecharKpiTable() {
      this.selectedKpi = null;
      this.kpiPassageiros = [];
      this.loadingKpiTable = false;
    },
    onStatusClick(statusKey) {
      if (!this.hasKpis || !statusKey) return;
      const allowed = { nunca: true, inativos: true, ativos: true, unico: true };
      if (!allowed[statusKey]) return;
      if (this.selectedKpi === statusKey) {
        this.fecharKpiTable();
        return;
      }
      this.selectedKpi = statusKey;
      this.kpiPassageiros = [];
      this.loadKpiPassageiros(statusKey);
    },
    onDonutDataPointSelection(event, chartContext, config) {
      if (this.loadingPdf) return;
      const idx = config && config.dataPointIndex;
      if (idx == null || idx < 0) return;
      // ignora dessseleção do ApexCharts (clique repetido na mesma fatia)
      const selected = config.selectedDataPoints && config.selectedDataPoints[0];
      if (Array.isArray(selected) && selected.length === 0) {
        if (this.selectedKpi) this.fecharKpiTable();
        return;
      }
      const item = (this.statusAdesao || [])[idx];
      if (!item || !item.key) return;
      this.onStatusClick(item.key);
    },
    onDonutLegendClick(chartContext, seriesIndex) {
      if (this.loadingPdf) return;
      if (seriesIndex == null || seriesIndex < 0) return;
      const item = (this.statusAdesao || [])[seriesIndex];
      if (!item || !item.key) return;
      this.onStatusClick(item.key);
      return false;
    },
    loadKpiPassageiros(kpiKey) {
      const body = this.buildFilterBody();
      const requestSeq = (this._kpiRequestSeq = (this._kpiRequestSeq || 0) + 1);

      this.loadingKpiTable = true;
      this.kpiPassageiros = [];

      apiController.request(apiController.endpoints.getAdocaosistemapassageiros, {
        data: { ...body, status: kpiKey },
        onSuccess: (response) => {
          if (requestSeq !== this._kpiRequestSeq) return;
          if (this.filterCacheKey(this.buildFilterBody()) !== this.lastFilterKey) return;
          if (this.selectedKpi !== kpiKey) return;
          this.kpiPassageiros = response.data || [];
          this.loadingKpiTable = false;
          this.$nextTick(() => this.scrollToKpiTable());
        },
        onError: () => {
          if (requestSeq !== this._kpiRequestSeq) return;
          if (this.selectedKpi !== kpiKey) return;
          this.kpiPassageiros = [];
          this.loadingKpiTable = false;
        },
      });
    },
    scrollToKpiTable() {
      const el = this.$refs.sectionKpiTable;
      if (el && el.$el) {
        el.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } else if (el && el.scrollIntoView) {
        el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    },
    buildFilterBody() {
      return {
        idClientes: this.idClientesSelected || [],
        idUnidades: this.idUnidadesSelected || [],
        lideres: this.lideresSelected || [],
        idTurnosViagem: this.idTurnosViagemSelected || [],
        idEscalas: this.idEscalasSelected || [],
        tipo: this.tipoSelected || 'todos',
        dti: DateUtils.getDateSQLFormatted(this.dti),
        dtf: DateUtils.getDateSQLFormatted(this.dtf),
        dias_inativo: this.diasInativo || 7,
      };
    },
    filterCacheKey(body) {
      return JSON.stringify(body);
    },
    populaRelatorio() {
      this.$refs.form.validate();
      if (!this.formValidado) return;
      if (!this.dti || !this.dtf) return;

      const body = this.buildFilterBody();
      this.lastFilterKey = this.filterCacheKey(body);
      this.resetTabCache();
      this.tab = 0;
      this.kpis = null;
      this.statusAdesao = [];
      this.evolucao = { diario: [], semanal: [], mensal: [] };
      this.loadingResumo = true;

      apiController.request(apiController.endpoints.getAdocaosistemaresumo, {
        data: body,
        onSuccess: (response) => {
          if (this.filterCacheKey(body) !== this.lastFilterKey) return;
          const data = response.data || {};
          this.kpis = data.kpis || null;
          this.statusAdesao = data.status_adesao || [];
          this.evolucao = data.evolucao || { diario: [], semanal: [], mensal: [] };
          this.loadingResumo = false;
        },
        onError: () => {
          this.loadingResumo = false;
        },
      });
    },
    ensureTabLoaded(tabIndex) {
      const dimensao = TAB_DIMENSAO[tabIndex];
      if (!dimensao) return;
      if (this.loadingTab[dimensao]) return;
      // Sempre recarrega ao abrir a aba (não reutiliza dados de consulta anterior)
      this.$set(this.tabLoaded, dimensao, false);
      this.loadTabData(dimensao);
    },
    loadTabData(dimensao, onDone) {
      const body = this.buildFilterBody();
      const requestKey = this.filterCacheKey(body);
      if (this.loadingTab[dimensao]) {
        if (typeof onDone === 'function') onDone();
        return;
      }

      this.$set(this.tabLoaded, dimensao, false);
      this.$set(this.loadingTab, dimensao, true);

      if (dimensao === 'base') {
        this.baseAnalitica = [];
        apiController.request(apiController.endpoints.getAdocaosistemabase, {
          data: body,
          onSuccess: (response) => {
            if (requestKey !== this.lastFilterKey) return;
            this.baseAnalitica = response.data || [];
            this.$set(this.tabLoaded, 'base', true);
            this.$set(this.loadingTab, 'base', false);
            if (typeof onDone === 'function') onDone();
          },
          onError: () => {
            if (requestKey !== this.lastFilterKey) return;
            this.baseAnalitica = [];
            this.$set(this.loadingTab, 'base', false);
            if (typeof onDone === 'function') onDone();
          },
        });
        return;
      }

      const keyMap = {
        cad: 'por_cad',
        gestor: 'por_gestor',
        cliente: 'por_cliente',
        tipo: 'por_tipo',
      };
      if (dimensao === 'escala_turno') {
        this.agrupamentos.por_escala = [];
        this.agrupamentos.por_turno_viagem = [];
      } else if (keyMap[dimensao]) {
        this.agrupamentos[keyMap[dimensao]] = [];
      }

      apiController.request(apiController.endpoints.getAdocaosistemaagrupamento, {
        data: { ...body, dimensao },
        onSuccess: (response) => {
          if (requestKey !== this.lastFilterKey) return;
          const data = response.data || {};
          if (dimensao === 'escala_turno') {
            this.agrupamentos.por_escala = data.por_escala || [];
            this.agrupamentos.por_turno_viagem = data.por_turno_viagem || [];
          } else {
            const storeKey = keyMap[dimensao];
            if (storeKey) {
              this.agrupamentos[storeKey] = data.rows || [];
            }
          }
          this.$set(this.tabLoaded, dimensao, true);
          this.$set(this.loadingTab, dimensao, false);
          if (typeof onDone === 'function') onDone();
        },
        onError: () => {
          if (requestKey !== this.lastFilterKey) return;
          this.$set(this.loadingTab, dimensao, false);
          if (typeof onDone === 'function') onDone();
        },
      });
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    waitForTabLoaded(dimensao) {
      return new Promise((resolve) => {
        if (this.tabLoaded[dimensao]) {
          resolve();
          return;
        }
        let attempts = 0;
        const maxAttempts = 150;
        const tick = () => {
          if (this.tabLoaded[dimensao]) {
            resolve();
            return;
          }
          attempts += 1;
          if (attempts > maxAttempts) {
            resolve();
            return;
          }
          if (!this.loadingTab[dimensao]) {
            this.loadTabData(dimensao, () => {
              if (this.tabLoaded[dimensao]) resolve();
              else setTimeout(tick, 200);
            });
            return;
          }
          setTimeout(tick, 200);
        };
        tick();
      });
    },
    async ensureCurrentTabLoadedForPdf() {
      const dimensao = TAB_DIMENSAO[this.tab];
      if (dimensao) {
        await this.waitForTabLoaded(dimensao);
      }
    },
    pdfSectionEl(tabIndex) {
      if (tabIndex === 0) return this.$refs.sectionExecutive;
      if (tabIndex >= 1 && tabIndex <= 4) return this.$refs.sectionGroup;
      if (tabIndex === 5) return this.$refs.sectionSchedule;
      if (tabIndex === 6) return this.$refs.sectionBase;
      return null;
    },
    html2canvasOptions(el) {
      return {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff',
        scrollX: 0,
        scrollY: -window.scrollY,
        windowWidth: Math.max(el.scrollWidth, el.clientWidth, 1200),
      };
    },
    addCanvasPagesToPdf(doc, canvas, { addPageBefore = false, title = '' } = {}) {
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 10;
      const titleSpace = title ? 8 : 0;
      const usableWidth = pageWidth - margin * 2;
      const usableHeight = pageHeight - margin * 2 - titleSpace;
      const imgWidth = usableWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const imgData = canvas.toDataURL('image/jpeg', 0.92);

      let heightLeft = imgHeight;
      let y = margin + titleSpace;

      if (addPageBefore) doc.addPage();
      if (title) {
        doc.setFontSize(12);
        doc.setTextColor(40);
        doc.text(title, margin, margin + 4);
      }
      doc.addImage(imgData, 'JPEG', margin, y, imgWidth, imgHeight);
      heightLeft -= usableHeight;

      while (heightLeft > 0) {
        y = margin - (imgHeight - heightLeft);
        doc.addPage();
        doc.addImage(imgData, 'JPEG', margin, y, imgWidth, imgHeight);
        heightLeft -= usableHeight;
      }
    },
    async captureElToPdf(doc, el, { addPageBefore = true, title = '' } = {}) {
      if (!el) return;
      const canvas = await html2canvas(el, this.html2canvasOptions(el));
      this.addCanvasPagesToPdf(doc, canvas, { addPageBefore, title });
    },
    async captureGroupCompToPdf(doc, comp, baseTitle) {
      if (!comp || typeof comp.prepareForPdfExport !== 'function') return;

      try {
        await comp.prepareForPdfExport();
        await this.$nextTick();
        await this.sleep(400);

        const totalPages =
          typeof comp.getChartTotalPages === 'function' ? comp.getChartTotalPages() : 1;

        for (let page = 1; page <= totalPages; page += 1) {
          if (typeof comp.goToChartPage === 'function') {
            await comp.goToChartPage(page);
          }
          await this.$nextTick();
          // Tempo para ApexCharts remontar o SVG da página
          await this.sleep(700);

          const chartEl = typeof comp.getChartEl === 'function' ? comp.getChartEl() : null;
          const chartTitle =
            totalPages > 1
              ? `${baseTitle} — ${this.$t('diagSystemAdoption.groupFilters.pageOf', {
                  page,
                  pages: totalPages,
                })}`
              : baseTitle;
          await this.captureElToPdf(doc, chartEl, {
            addPageBefore: true,
            title: chartTitle,
          });
        }

        const tableEl = typeof comp.getTableEl === 'function' ? comp.getTableEl() : null;
        await this.captureElToPdf(doc, tableEl, {
          addPageBefore: true,
          title: baseTitle,
        });
      } finally {
        if (typeof comp.restoreAfterPdfExport === 'function') {
          comp.restoreAfterPdfExport();
        }
      }
    },
    writePdfCoverPage(doc) {
      const margin = 14;
      doc.setFontSize(18);
      doc.setTextColor(25, 118, 210);
      doc.text(this.$t('diagSystemAdoption.exportPdfTitle'), margin, 24);

      doc.setFontSize(11);
      doc.setTextColor(80);
      const periodo = `${DateUtils.getDateSQLFormatted(this.dti) || ''} — ${DateUtils.getDateSQLFormatted(this.dtf) || ''}`;
      doc.text(`${this.$t('diagSystemAdoption.exportPdfPeriod')}: ${periodo}`, margin, 38);
      doc.text(
        `${this.$t('diagSystemAdoption.filters.inactiveDays')}: ${this.diasInativo || 7}`,
        margin,
        46
      );

      const tipoMap = {
        todos: this.$t('diagSystemAdoption.filters.typeAll'),
        ml: this.$t('diagSystemAdoption.filters.typeMl'),
        terceiro: this.$t('diagSystemAdoption.filters.typeThird'),
      };
      doc.text(
        `${this.$t('diagSystemAdoption.filters.type')}: ${tipoMap[this.tipoSelected] || this.tipoSelected}`,
        margin,
        54
      );

      doc.text(
        `${this.$t('diagSystemAdoption.exportPdfTab')}: ${this.currentTabTitle}`,
        margin,
        62
      );

      const emitted = new Date();
      const emittedStr = emitted.toLocaleString(this.$i18n.locale || 'pt-BR');
      doc.text(`${this.$t('diagSystemAdoption.exportPdfEmittedAt')}: ${emittedStr}`, margin, 70);

      doc.setFontSize(10);
      doc.setTextColor(120);
      doc.text(this.$t('diagSystemAdoption.exportPdfHint'), margin, 86, { maxWidth: 270 });
    },
    async capturePlainSectionToPdf(doc, tabIndex, title) {
      await this.$nextTick();
      await this.sleep(700);
      const el = this.pdfSectionEl(tabIndex);
      await this.captureElToPdf(doc, el, { addPageBefore: true, title });
    },
    async exportarAnalisePdf() {
      if (!this.hasKpis || this.loadingPdf) return;
      this.loadingPdf = true;
      const tabIndex = this.tab;

      try {
        await this.ensureCurrentTabLoadedForPdf();
        await this.$nextTick();
        await this.sleep(150);

        const doc = new jsPDF({
          orientation: 'landscape',
          unit: 'mm',
          format: 'a4',
          compress: true,
        });
        this.writePdfCoverPage(doc);

        const title = this.currentTabTitle;

        if (tabIndex === 0 || tabIndex === 6) {
          await this.capturePlainSectionToPdf(doc, tabIndex, title);
        } else if (tabIndex >= 1 && tabIndex <= 4) {
          if (this.$refs.groupComp) {
            await this.captureGroupCompToPdf(doc, this.$refs.groupComp, title);
          }
        } else if (tabIndex === 5) {
          if (this.$refs.groupSchedule) {
            await this.captureGroupCompToPdf(
              doc,
              this.$refs.groupSchedule,
              this.$t('diagSystemAdoption.group.bySchedule')
            );
          }
          if (this.$refs.groupShift) {
            await this.captureGroupCompToPdf(
              doc,
              this.$refs.groupShift,
              this.$t('diagSystemAdoption.group.byTripShift')
            );
          }
        }

        const stamp = new Date().toISOString().replace(/[:.]/g, '-');
        doc.save(`adocaosistema_${stamp}.pdf`);
      } catch (err) {
        console.error('PDF export failed', err);
      } finally {
        this.loadingPdf = false;
      }
    },
  },
};
</script>

<style scoped>
.diag-adocao {
  max-width: 1600px;
  margin-left: auto;
  margin-right: auto;
}
.toolbar-card,
.kpi-card {
  border-radius: 10px;
}
.kpi-card {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}
.kpi-card--clickable {
  cursor: pointer;
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}
.kpi-card--clickable:hover {
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12);
  transform: translateY(-1px);
}
.kpi-card--selected {
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.45), 0 3px 10px rgba(0, 0, 0, 0.12);
}
</style>

<style>
.diag-adocao .chart-card {
  border-radius: 10px;
}
.diag-adocao .apexcharts-pie-area {
  cursor: pointer;
}
.diag-adocao .apexcharts-legend-series {
  cursor: pointer;
}
</style>
